import React, { useEffect } from 'react';
import fallback from '../../../_Translations/generated/PackageSearch.en.t.json';
import Keys from '../../../_Translations/generated/PackageSearch.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import PackageSearchStore from './PackageSearchStore';

const PackageSearchValidationErrorMessage = observer(
  ({ store, errorKeys }: { store?: PackageSearchStore; errorKeys?: string[] }) => {
    if (!store) {
      return <></>;
    }
    useEffect(() => {
      if (errorKeys) {
        if (errorKeys?.length) {
          const allErrors = [...(store.validationErrorMessages || [])];
          errorKeys.map(errorKey => {
            if (!allErrors.includes(errorKey)) {
              allErrors.push(errorKey);
            }
          });
          store.setValidationErrorMessages(allErrors);
        } else {
          store.setValidationErrorMessages([]);
          store.validateParamsAndShowError();
        }
      }
    }, [errorKeys]);

    const { t } = useTranslation('PackageSearch', fallback, Keys);
    const errorMessages = toJS(store.validationErrorMessages);
    if (!store.showValidationErrorMessage || !store.validationErrorMessages?.length) return null;
    return (
      <div className="iso__package__search_validation_error">
        <div className="mb-2 mt-2">
          <FontAwesomeIcon icon={faExclamationCircle} />
          <span className="ml-1">{t(Keys.errorMessageTitle)} </span>
        </div>
        {(errorMessages || [])?.map((errorMessage, idx) => {
          return <div key={idx}>- {t(errorMessage)}</div>;
        })}
      </div>
    );
  }
);

export default PackageSearchValidationErrorMessage;
